import React, { useState } from 'react';
import { useHistory } from "react-router-dom";
import API from "../../Services/BaseService";
import { useForm } from "react-hook-form";
import appstore from '../../assets/img/appstore.png';
import googleplay from '../../assets/img/googleplay.png';
import gasoline from '../../assets/img/gasoline-pump.svg';
import speedometer from '../../assets/img/speedometer.svg';
import cars01 from '../../assets/img/cars01.png';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Loading from "../../Component/Loading/Loading";
import InVoice from './InVoice';
import {CopyToClipboard} from 'react-copy-to-clipboard';
import car from '../../assets/img/car.svg';
import barcode from '../../assets/img/barcode.svg';
import GatePassAccept from "../../Container/History/GatePassAccept";
import Popup from "../../Component/Popup/Popup";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import PageNotFound from '../FallBackUI/PageNotFound';

const History = () => {
    const history = useHistory();
	const [loading, setLoading] = useState(true);
    const [historyDetials,setHistoryDetials]=useState([]);
    const successData = useSelector(state => state.LoginReducer.payload);	
	const [VINNumber, setVINNumber] = useState("");
	const [year, setYear] = useState("");
	const [make, setMake] = useState("");
	const [model, setModel] = useState("");
	const [vinError,setVinError] = useState("");
	const[paymentstatus, setPaymentStatus] = useState("");
	const [inventoryNo, setInventoryNo] = useState("");
	const [billOfSale, setBillOfSale] = useState("");
	const [titlestatus, setTitleStatus] = useState("");
	const [gatepassstatus, setGatePassStatus] = useState("");
	const [gatepasscode, setGatePassCode] = useState("");
	const [transportationStatus, setTranportationStatus] = useState("");

	const [carDetail,setCarDetail]=useState([]);
    const [order,setOrder] = useState("");
    const [copySuccess, setCopySuccess] = useState('');
    const [copied, setCopied] = useState(false);
    const [buttonDisable, setButtonDisable] = useState(false);
	const [carId, setCarId] = useState(null);
	const [buyerId, setBuyerId] = useState(null);
	const[scheduletodate,setScheduleToDate]=useState(null);
  	const[scheduleDate,setScheduleDate]=useState(null);
	const [fromDateError,setFromDateError] = useState("");
	const [isOpenAccept, setIsOpensAccept] = useState(false);

	const [errors, setErrors] = useState("");
    const [errorFlag, setErrorFlag] = useState(false);
	
	const togglePopupAccept = () => {
        setIsOpensAccept(!isOpenAccept);
    }
	const gatepassColorChange = () => {
        console.log("gate passColor Change")

		gethistory();
    }
	const gethistory=()=>{
        let request={
          seller_dealer_id: successData.seller_dealer_id,key:10,
		  seller_id:successData.seller_id,
				seller_token:successData.seller_token ,
        }
        console.log("historyDetials",request)
        API.post('historyDetails/condition',request).then(res=>{
            console.log("historyDetials response",res.data.data);
			if (res.data.success === true) {
            setCarDetail(res.data.data);
            console.log("car Detail",res.data.data);
			// setCarId(res.data.data[0].car_id)
			// setBuyerId(res.data.data[0].buyer_dealer_id)

            setLoading(false);
		}
        else {
            setErrors(res.data.error.name)
            setErrorFlag(true)
        }
    }).catch(function (error) {
        if (error.response) {
            setErrors(error.response.data.error)
            setErrorFlag(true)
        }
    });
      }
	  
	const historyorder =() =>{
		let request={
		seller_dealer_id: successData.seller_dealer_id,
        order:order

		}
        console.log("history order",request)
		API.post('historyDetailsOrder/condition',request).then(res=>{
            console.log("history order response",res.data.data);
			if (res.data.success === true) {
            setCarDetail(res.data.data);
		 
           
        }
        else {
            setErrors(res.data.error.name)
            setErrorFlag(true)
        }
    }).catch(function (error) {
        if (error.response) {
            setErrors(error.response.data.error)
            setErrorFlag(true)
        }
    });
	}
	const searchCarDetail = () => {
		setVinError("")
		setFromDateError("")

	   if(VINNumber.length>0 && VINNumber.length < 6){
		 setVinError("VIN number must have last 6 digit")
		 return;
	   }
	   else if(VINNumber.length > 6){
		setVinError("VIN number accept only last 6 digit")
		return;
	  }
	  if(scheduletodate){
		if(!scheduleDate){
		setFromDateError("From Date is required")
		return;
		}
	  }
	  if(scheduleDate){
		if(!scheduletodate){
		setFromDateError("To Date is required")
		return;
		}
	  }
	  let request={
		seller_dealer_id: successData.seller_dealer_id,
		make: make,
		model: model,
		year: year,
		vin_no: VINNumber,
	    fromdate: scheduleDate==null ? "" : convert(scheduleDate),
  		todate:scheduleDate==null? "" : scheduletodate==null?convert(new Date()):convert(scheduletodate),
		  payment_mode: paymentstatus,
		  car_id: inventoryNo,
		  bill_of_sale_id: billOfSale,
		  title_status: titlestatus,
		  gatepass_status: gatepassstatus,
		  gatepass: gatepasscode,
		  transportation_status: transportationStatus,
	  }
	  console.log("active data",request);
		API.post("historyDetailsSearch/condition",request)
		.then((res)=>{
			if (res.data.success === true) {
			setCarDetail(res.data.data);
		  console.log("urcar_search data",res.data.data);
		  
		}
        else {
            setErrors(res.data.error.name)
            setErrorFlag(true)
        }
    }).catch(function (error) {
        if (error.response) {
            setErrors(error.response.data.error)
            setErrorFlag(true)
        }
    });
	  }
	  function convert(str) {
		var date = new Date(str),
		  mnth = ("0" + (date.getMonth() + 1)).slice(-2),
		  day = ("0" + date.getDate()).slice(-2);
		return [date.getFullYear(), mnth, day].join("-");
	  }
	  const handleDateChangeRaw = (e) => {
		e.preventDefault();
		}  
	  const gatePass = (item) =>{
		setCarId(item.car_id);
		setBuyerId(item.buyer_dealer_id)
		togglePopupAccept()
	}

	  function copytoclipboard(e) {
		document.execCommand('copy');
		e.target.focus();
		setCopySuccess('Copied!');
	  };

	  useEffect(() => {
        gethistory();
		historyorder();
      },[order]);
    return (
        <div>
			
            <main id="main" class="inner-page">
			{errorFlag === true ? <PageNotFound error={errors} /> :
			<>
			{loading ? <Loading /> :
   
    <div id="historyPage" class="historyPage">
		<div class="container" >
			<div class="lotfeeblock col-lg-12">
				<div class="section-title">
				  <h2>history</h2>
				</div>
				<div class="row content">
					
					<div class="col-lg-12 col-md-12 col-sm-12 historyblock">
					
								
								<div class="row">
       
       <div class="searchlistform col-lg-12">
                   <div class="searchblock">
                   <div class="form-group">
                           <label class="control-label" for="location">Year</label> 
                           <input class="form-control border-end-0" type="text"  id="location" placeholder="Enter Car Year"
                           onChange={(e) => setYear(e.target.value)}/>
                       </div>
                       
                                                
                       <div class="form-group">
                           <label class="control-label" for="dealername">Make</label> 
                           <input class="form-control border-end-0" type="text"  id="dealername" placeholder="Enter Car Make"
                           onChange={(e) => setMake(e.target.value)}/>
                       </div>
                                                
                       <div class="form-group">
                           <label class="control-label" for="dealername">Model</label> 
                           <input class="form-control border-end-0" type="text"  id="dealername" placeholder="Enter Car Model"
                           onChange={(e) => setModel(e.target.value)}/>
                       </div>

                   <div class="form-group ">
                           <label class="control-label" for="date">VIN No</label> 
                           <input class="form-control border-end-0 " type="text"  id="date" placeholder="Enter Last 6 Digit"
                           onChange={(e) => setVINNumber(e.target.value)}/>
                        
                        </div>

						<div class="form-group">
                           <label class="control-label" for="location">Inventory</label> 
                           <input class="form-control border-end-0" type="text"  id="location" placeholder="Enter Inventory no"
                           onChange={(e) => setInventoryNo (e.target.value)}/>
                           </div>

					   <div className="form-group dateBlock">
                                        <label className="control-label" for="date">From Date</label> 
                                        {/* <input className="form-control border-end-0 " type="date" value={scheduleDate}  id="date" onKeyDown={onKeydowninSearch} placeholder="DD-MM-YYYY" onChange={(e) => setScheduleDate(e.target.value)}></input> */}
                                        <DatePicker
                                                        className="form-control textbox" name="date" id="date"
                                                        autoComplete="off"
                                                        selected={scheduleDate}
                                                        onChange={(date) => setScheduleDate(date)}
                                                        isClearable
                                                        placeholderText="Date"
                                                        required
                                                        onChangeRaw={handleDateChangeRaw}
                                                    />
                                   
                                    </div>
                                    <div className="form-group dateBlock">
                                        <label title=" Select From date first to proceed !" className="control-label" for="todate">To Date</label> 
                                        {scheduleDate!=""?
                                        // <input className="form-control border-end-0 " type="date"  id="todate" onKeyDown={onKeydowninSearch} placeholder="DD-MM-YYYY" value={scheduletodate} onChange={(e) => setScheduleToDate(e.target.value)}></input>
                                        <DatePicker
                                                        className="form-control textbox" name="todate" id="todate"
                                                        selected={scheduletodate}
                                                        onChange={(date) => setScheduleToDate(date)}
                                                        isClearable
                                                        placeholderText="Date"
                                                        required
                                                        onChangeRaw={handleDateChangeRaw}
                                                    />:
                                                    <DatePicker
                                                    className="form-control textbox" disabled name="todate" id="todate"
                                                    selected={scheduletodate}
                                                    onChange={(date) => setScheduleToDate(date)}
                                                    isClearable
                                                    placeholderText="Date"
                                                    required
                                                    onChangeRaw={handleDateChangeRaw}
                                                />}
                                    </div>                      
                           		 <div class=" form-group searchbtn">
                                {/*<img src={searchicon} onClick={searchCarDetail}/>*/}
                               <button  onClick={searchCarDetail}><i class="bx bx-search"></i></button> 
								</div>
								</div>
							</div>	
						</div>
						
                <div class="errorMsgBox col-lg-12">
								<p className="form-input-error" >{vinError}</p>
								<p className="form-input-error" >{fromDateError}</p>

								</div>
						</div>
						<div class="row">
	   <div class="searchlistform search2 col-lg-12">
	                     
	   <div class="searchblock">
	   <div class="form-group carStatus">
						 <label class="control-label" for="dealername">Gate Pass Status</label> 
						 <select id="drop" placeholder="Car Status" name="dropoption"  className="form-control border-end-0 csSelect" 
                                onChange={(e) => setGatePassStatus(e.target.value)}>
                                  <option style={{"display":"none" }}>Select</option>
                                  <option value="yes">yes</option>
                                  <option value="no">no</option>
                        </select>
                           
                          </div>
						  <div class="form-group">
                           <label class="control-label" for="dealername">Title Status</label> 
						   <select id="drop" placeholder="Car Status" name="dropoption"  className="form-control border-end-0 csSelect" 
                                onChange={(e) => setTitleStatus(e.target.value)}>
                                  <option style={{"display":"none" }}>Select</option>
                                  <option value="Title With Seller">Title with Seller</option>
                                  <option value="Title With Urs2ndlot">Title with Urs2ndlot</option>
								  <option value="Ttile With Buyer">Title with Buyer</option>
                        </select>
                       </div>
					   <div class="form-group">
                           <label class="control-label" for="location">GatePassCode</label> 
                           <input class="form-control border-end-0" type="text"  id="location" placeholder="Enter Gate pass code"
                           onChange={(e) => setGatePassCode(e.target.value)}/>
                       </div>
					   <div class="form-group">
                           <label class="control-label" for="location">Transportation Status</label> 
                           <select id="drop" placeholder="Car Status" name="dropoption"  className="form-control border-end-0 csSelect" 
                                onChange={(e) => setTranportationStatus(e.target.value)}>
                                  <option style={{"display":"none" }}>Select</option>
                                  <option value="Car With Seller">Car with seller</option>
                                  <option value="In Transit">In Transit</option>
								  <option value="Delivered">Delivered</option>
								  </select>
                       </div>

					   <div class=" form-group searchbtn">
										{/*<img src={searchicon} onClick={searchCarDetail}/>*/}
										<button  onClick={searchCarDetail}><i class="bx bx-search"></i></button> 
									</div>        
     </div>
      </div>
      </div>

			
						
	   <div class="col-lg-12 col-md-12 col-sm-12 historyblock"> 		
								<div class="hisHead">
									<p>{carDetail.length} vehicles sold</p>
									{/* <div class="sortBy">
											<div class="col-sm-12 form-group">  
												<div class="tbox">			
												<select id="" class="form-control box"
												 onChange={(e) => setOrder(e.target.value)}>
									   				<option style={{"display":"none" }}>Sort By</option>
													<option value="date">Sold Date</option>
													<option value="ach date">ACH Date</option>
													<option value="title status">Title Status</option>
													<option value="getpass code">Gate Pass Code</option>
													{/* <option value="USA">By Year</option>
													<option value="USA">Make</option>
													<option value="USA">Model</option> */}
												{/* </select>				
												</div> 
											</div>
									</div>  */}
								</div>
								
								
								{carDetail.length > 0 ? carDetail.map((item) =>
                            
						<div class="lotfee-inner col-lg-12">
							<div class="row">							
								<div class="col-lg-4">									
									<div class="car-item">
										<div class="pickupdetailcontent">
											<p class="billsalesno">Bill Of sale# {item.bill_of_sale_id}</p>
											<p class="billsalesno pull-right">Inventory No - {item.inventory_no}</p>
										</div>	
										
							                  														
										<img src={item.image} class="carImg" alt="..."/>
									</div>
								</div>
								<div class="col-lg-4 historyMiddle">
									 <div class="cars-content">		
											<h3><a >{item.year} {item.make} {item.model}</a></h3>
											<div class="d-flex align-items-center mb-3">
											  <p class="details"><img src={speedometer}  alt=""/><span>{item.mileage} m</span></p>&nbsp;&nbsp;&nbsp;&nbsp;
											  <p class="details"><img src={gasoline} alt=""/><span>{item.fuel_type}</span></p>
											</div>
											
					
						
						<div class="col-md-12 carpoints pl-0">
						<div className="label">VIN Number</div>			  
							<div class="carpoint">
							
								<img src={car}  alt=""/>
								<span>{item.vin_no}</span>
								<CopyToClipboard text={item.vin_no} onCopy={() => setCopied(true)}>
								<span title="Copy" onClick={copytoclipboard} className="copyImg"><i class="icofont-copy"></i></span>
								</CopyToClipboard>
								{/* <img src={book} onClick={copytoclipboard} alt=""/>  */}
								<img src={barcode}  alt=""/>
								
							</div>
							{/* {copied ? <p>Copied !</p> : ""} */}
						</div>
						{/* <p>{copySuccess}</p> */}

				
											
											<div class="cars-prices invoice_link">
												<a class="redBtn" 
												onClick={() => history.push({pathname: "/invoice",
												state: {backURL:"/history", billOfSales:item.bill_of_sale_id, gatePass:item.gatepass_id, year:item.year, make:item.make, model:item.model, buyerId:item.buyer_dealer_id,price:item.price, lotFee:item.seller_lot_fee, soldDate:item.sold_date,  VinNo:item.vin_no , inventoryNo:item.inventory_no, buyertax: item.buyer_tax_id,license: item.buyer_license}
											})}>Invoice</a>
													{/* {carDetail[0].days === 1 || carDetail[0].days == null || carDetail[0].days == ""?<p class="remaindays">{carDetail[0].days} day still to go</p>:
													<p class="remaindays">{carDetail[0].days} days still to go</p>}											 */}
											</div>
											{item.transportation_status_name == "Car with seller" ?<h3>Delivery status- <span>Car with Us</span></h3>:
											<h3>Delivery status- <span>{item.transportation_status_name}</span></h3>}

											
											<div class="cars-prices gatepass">
											<a class="cta-btns" >Price - ${item.price}</a>
									{/* {item.gatepass_id==""||item.gatepass_id==undefined || item.gatepass_id==null?"": */}

												<a class={`cta-btns-primary ${(item.transportation_flag == 2) && "redBtn"}`}  onClick={()=>{item.transportation_flag == 1 && gatePass(item)}} >Gate Pass Code - {item.gatepass_id}</a>
											</div>
										  </div>
								</div>
								<div class="col-lg-4 sliderBlock">
									<p class="solddate"><span>Sold Date {item.sold_date}</span></p>
									{item.title_status_name == "Title with Seller" ? <h3>Title status - <span class="orange"> Title with Us</span></h3>:
                                           <h3>Title status - <span class="orange"> {item.title_status_name}</span></h3>}
									{/* <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1</p>									 */}
									<h3>Vehicle Title</h3>									
									<form id="msform">
									  <ul id="progressbar">
										<li className={item.vehicle_title_status ==1 ? "active" : ""} >{item.title_date1}</li>
										<li className={item.vehicle_title_status ==2 ? "active" : ""} >{item.title_date2}</li>
										{item.vehicle_title_status !== 3 ? 
										<li className={item.vehicle_title_status ==3 ? "active" : ""} >{item.estimate_title_date}</li>:
										<li className={item.vehicle_title_status ==3 ? "active" : ""} >{item.title_date3}</li>}
									  </ul>
									</form>									
								</div>		
							</div>
						</div>): <div class="col-lg-12 nodata"><p>No Data Found</p> </div>}
						</div>
					</div>
					
					
					
					
					
				</div>
			</div>
		
    </div>}
	</>}

    <section id="playstoreBlock" class="playstoreBlock">
      <div class="container">

        <div class="row content">
          <div class="col-lg-12">
            <img src={appstore} />
            <img src={googleplay} />
		   
          </div>
         
        </div>
      </div>
    </section>
    {isOpenAccept && <Popup
		isClose={false}
		content={<>
		<GatePassAccept toggle={togglePopupAccept} carId={carId} buyerId={buyerId} gatepassColorChange={gatepassColorChange}/>
		</>}
		handleClose={togglePopupAccept}
	/>}	
  </main>
        </div>
    )
}
export default History;